import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ArtistOffers.css";

const BASE_URL = "http://localhost:8080/api/offers";

const ArtistOffers = () => {
  const [offers, setOffers] = useState([]);
  const [selectedOfferId, setSelectedOfferId] = useState(null); 
  const [history, setHistory] = useState([]);
  const [counterData, setCounterData] = useState({ price: "", note: "" });
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("ALL");

  const token = localStorage.getItem("authToken");

  const fetchAllOffers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOffers(response.data);
    } catch (err) {
      console.error("Error fetching offers:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllOffers();
  }, [token]);

  const handleViewHistory = async (offerId) => {
    try {
      const response = await axios.get(`${BASE_URL}/history/${offerId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setHistory(response.data);
      setSelectedOfferId(offerId);
    } catch (err) {
      alert("Failed to fetch history.");
    }
  };

  const handleCounterOffer = async (offer, paintingId) => {
    if (!counterData.price) return alert("Please enter a counter price!");

    try {
        let url = "";
        if (offer.seriesOffer) {
            url = `${BASE_URL}/make/series`;
        } else {
            url = `${BASE_URL}/make/${paintingId}`;
        }

        const payload = {
            offerAmount: counterData.price,
            message: counterData.note,
            role: "ARTIST",
            offerId: offer.id,
            seriesName: offer.seriesName 
        };

        await axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` },
        });

        alert("Counter offer sent successfully ✅");
        setCounterData({ price: "", note: "" });
        fetchAllOffers(); 
        setSelectedOfferId(null); 
    } catch (err) {
        console.error(err);
        alert("Failed to send counter.");
    }
  };

  const handleAcceptOffer = async (offerId) => {
      if(!window.confirm("Are you sure you want to accept this offer?")) return;

      try {
          await axios.put(`${BASE_URL}/${offerId}/accept`, {}, {
              headers: { Authorization: `Bearer ${token}` },
          });
          alert("Offer Accepted! The buyer has been notified.");
          fetchAllOffers();
      } catch (err) {
          console.error(err);
          alert("Failed to accept offer.");
      }
  };

  const formatDate = (dateString) => {
      if(!dateString) return "N/A";
      return new Date(dateString).toLocaleDateString("en-IN", {
          day: 'numeric', month: 'short', year: 'numeric'
      });
  };

  const filteredOffers = activeTab === "ALL" 
    ? offers 
    : offers.filter(o => o.status === activeTab);

  return (
    <div className="artist-dashboard">
      <div className="dashboard-header">
        <h2>Offer Management</h2>
        <div className="tabs">
            <button className={activeTab === "ALL" ? "active" : ""} onClick={() => setActiveTab("ALL")}>All</button>
            <button className={activeTab === "PENDING" ? "active" : ""} onClick={() => setActiveTab("PENDING")}>Pending</button>
            <button className={activeTab === "COUNTERED" ? "active" : ""} onClick={() => setActiveTab("COUNTERED")}>Countered</button>
        </div>
      </div>

      <div className="table-container">
        {loading ? (
            <div className="loading-state">Loading Data...</div>
        ) : filteredOffers.length === 0 ? (
            <div className="empty-state">No offers found.</div>
        ) : (
            <table className="offers-table">
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Type</th>
                        <th>Buyer</th>
                        <th>Latest Offer</th>
                        <th>Status</th>
                        <th>Last Message</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredOffers.map((offer) => (
                        <tr key={offer.id}>
                            <td className="item-cell">
                                <div className="item-info">
                                    {offer.seriesOffer ? (
                                        <div className="item-thumb series-thumb">Series</div>
                                    ) : (
                                        <img 
                                            src={offer.painting?.images?.[0]?.imageUrl || "https://via.placeholder.com/50"} 
                                            alt="art" 
                                            className="item-thumb" 
                                        />
                                    )}
                                    <span className="item-title">
                                        {offer.seriesOffer 
                                            ? `${offer.seriesName} (Series Bundle)` 
                                            : offer.painting?.title || "Unknown Art"}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <span className={`badge ${offer.seriesOffer ? "badge-series" : "badge-single"}`}>
                                    {offer.seriesOffer ? "Series" : "Single"}
                                </span>
                            </td>
                            <td>
                                <div className="buyer-info">
                                    <span className="buyer-name">{offer.user?.name}</span>
                                    <span className="buyer-email">{offer.user?.email}</span>
                                </div>
                            </td>
                            <td className="price-cell">₹ {offer.offerAmount?.toLocaleString("en-IN")}</td>
                            <td>
                                <span className={`status-badge status-${offer.status.toLowerCase()}`}>
                                    {offer.status}
                                </span>
                            </td>
                            <td className="msg-cell" title={offer.message}>{offer.message?.substring(0, 30)}...</td>
                            <td>
                                <div className="action-buttons">
                                    {/* View History */}
                                    <button 
                                        className="btn-icon btn-history" 
                                        onClick={() => handleViewHistory(offer.id)}
                                        title="View History"
                                    >
                                        <i className="fa-solid fa-clock-rotate-left"></i>
                                    </button>
                                    
                                    {/* ✅ Artist Actions Logic */}
                                    {offer.status === "ORDERED" ? (
                                        <span className="order-complete-tick" title="Order Placed"><i className="fa-solid fa-circle-check"></i></span>
                                    ) : (offer.status !== 'ACCEPTED' && offer.status !== 'REJECTED' && offer.status !== 'PAID') && (
                                        <button 
                                            className="btn-icon btn-accept" 
                                            onClick={() => handleAcceptOffer(offer.id)}
                                            title="Accept Offer"
                                        >
                                            <i className="fa-solid fa-check"></i>
                                        </button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )}
      </div>

      {/* --- HISTORY / COUNTER MODAL --- */}
      {selectedOfferId && (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h3>Offer Details & History</h3>
                    <button onClick={() => setSelectedOfferId(null)}><i className="fa-solid fa-xmark"></i></button>
                </div>
                
                <div className="modal-body">
                    <div className="history-list">
                        {history.map((h, index) => (
                            <div key={index} className={`history-item ${h.role === 'ARTIST' ? 'artist-side' : 'buyer-side'}`}>
                                <div className="history-meta">
                                    <span className="role-tag">{h.role}</span>
                                    <span className="history-date">{formatDate(h.date)}</span>
                                </div>
                                <div className="history-price">₹ {h.price?.toLocaleString("en-IN")}</div>
                                <p className="history-note">{h.note}</p>
                            </div>
                        ))}
                    </div>

                    {/* Only show counter form if not ordered/accepted */}
                    {/* Note: In production you might check status of `selectedOfferId` first */}
                    <div className="counter-form">
                        <h4>Send Counter Offer</h4>
                        <div className="form-row">
                            <input 
                                type="number" 
                                placeholder="New Amount (₹)" 
                                value={counterData.price} 
                                onChange={(e) => setCounterData({...counterData, price: e.target.value})}
                            />
                            <input 
                                type="text" 
                                placeholder="Note (Optional)" 
                                value={counterData.note} 
                                onChange={(e) => setCounterData({...counterData, note: e.target.value})}
                            />
                            <button 
                                className="btn-send-counter"
                                onClick={() => {
                                    const offer = offers.find(o => o.id === selectedOfferId);
                                    handleCounterOffer(offer, offer.painting?.id);
                                }}
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      )}

    </div>
  );
};

export default ArtistOffers;